import queryString from 'utils/queryString';
import { apiClientGetRequest } from '../lib/backendRequest';
import SETTINGS from '../settings';

export const transformCategories = (categories, initLabels = []) => {
  return categories.reduce((acc, category) => {
    const isValid =
      initLabels.filter((initLabel, initLabelIndex) => category[initLabelIndex] !== initLabel)
        .length === 0;

    if (isValid) {
      acc.push(category.slice(initLabels.length));
    }

    return acc;
  }, []);
};

const assetsApi = accessToken => ({
  getCategories: async () => {
    try {
      const response = await apiClientGetRequest(
        queryString.stringifyUrl('api/v1/editor/categories', {
          client_id: SETTINGS.CLIENT_ID,
        }),
        {
          headers: {
            Authorization: `Token ${accessToken}`,
          },
        },
      );

      const json = await response.json();

      return { data: json.data };
    } catch (error) {
      return { error };
    }
  },

  getAssets: async (categories = [], searchQuery = '', sinceId = undefined) => {
    try {
      const response = await apiClientGetRequest(
        queryString.stringifyUrl('api/v1/editor/list', {
          client_id: SETTINGS.CLIENT_ID,
          filter: categories.join(','),
          search: searchQuery.length > 0 ? searchQuery : undefined,
          since_id: sinceId,
        }),
        {
          headers: {
            Authorization: `Token ${accessToken}`,
          },
        },
      );

      const json = await response.json();

      return { data: json.data, hasNextPage: json.has_next_page };
    } catch (error) {
      return { error };
    }
  },
});

export default assetsApi;
